export const UserPermissions = {
  write: 'Write',
  read: 'Read',
} as const;
export type UserPermissions = (typeof UserPermissions)[keyof typeof UserPermissions];

export const userRoles: Record<string, string> = {
  read: 'Read',
  write: 'Write',
  author: 'Author',
  owner: 'Owner',
};
